// Stock's views' props, as zod (pages/ux-full components/stock.js CatalogTable): stock.catalog's answer as
// it is. Not in TOOL_VIEWS yet.
import { z } from 'zod';

const Id = z.string().min(1);

/** One stock.catalog row: a price book part with what stock keeps on it. */
export const CatalogPart = z.object({
  id: Id,
  code: z.string(),
  name: z.string(),
  type: z.enum(['material', 'equipment']),
  category: z.object({ id: Id, name: z.string() }).nullable(),
  unit: z.string(),
  priceCents: z.int(),
  /** Only for those who see our cost (pricebook.cost.view): absent otherwise, never null for it. */
  costCents: z.int().nullable().optional(),
  forSale: z.boolean(),
  active: z.boolean(),
  stock: z.object({
    vendor: z.object({ id: Id, name: z.string() }).nullable(),
    purchaseUnit: z.string().nullable(),
    unitsPerPurchase: z.string(),
    tracked: z.boolean(),
    bin: z.string().nullable(),
  }),
});
export type CatalogPart = z.infer<typeof CatalogPart>;

/** stock.catalog's rows: a page of the catalog. */
export const CatalogTableProps = z.object({ parts: z.array(CatalogPart) });
export type CatalogTableProps = z.infer<typeof CatalogTableProps>;

// ── Truck stock, concept A (BL-203, 27 Oct): the office's Stock page. stock.levels' answer by item, a
// level per place, with what the concept adds marked new. Quantities are strings in the item's unit, as
// stock.levels gives them ("5.000", "63"). ──

/** A place that keeps stock (stockLocations.list), with who has it (new). */
export const StockPlace = z.object({
  id: Id,
  name: z.string(),
  kind: z.enum(['warehouse', 'truck']),
  /** Who has it, in words: "Sam K."; the warehouse: "The shop" (new). */
  who: z.string().nullable(),
});
export type StockPlace = z.infer<typeof StockPlace>;

/** One item's level at one place (stock.levels). */
export const StockLevel = z.object({
  onHand: z.string(),
  min: z.string(),
  max: z.string(),
  countNeeded: z.boolean(),
  /** The last posted count that took it in, in words: "19 Oct"; null: never counted here (new). Absent:
   *  the answer doesn't say (stock.levels doesn't carry it yet), and the table draws no Last counted. */
  lastCounted: z.string().nullable().optional(),
  /** What's on hand at our cost: only for whoever sees our cost (pricebook.cost.view), absent otherwise. */
  costCents: z.int().nullable().optional(),
});
export type StockLevel = z.infer<typeof StockLevel>;

/** An item with its level in each place that keeps it. */
export const StockItemRow = z.object({
  itemId: Id,
  itemName: z.string(),
  code: z.string(),
  /** The unit a tech logs in: "each", "ft". */
  unit: z.string(),
  category: z.object({ id: Id, name: z.string() }),
  levels: z.record(z.string(), StockLevel),
});
export type StockItemRow = z.infer<typeof StockItemRow>;

/** The Stock page's table: one place (its own columns) or every place (a column each). */
export const StockTableData = z.object({
  places: z.array(StockPlace).min(1),
  rows: z.array(StockItemRow),
});
export type StockTableData = z.infer<typeof StockTableData>;
